import React from 'react';
import Navbar from '../../components/navbar/nav';
import Footer from '../../components/footer/footer';
import './contact.css';
import ServiceHighlights from '../../components/servicehighlights/ServiceHighlights';

function ContactLayout() {
    return (
        <div className="contact-layout">
            <Navbar />

            <main className="contact-main">
                {/* Hero con mensaje persuasivo */}
                <section className="about-hero">
                    <video className="about-hero-video" autoPlay loop muted playsInline>
                        <source src="/videos/guitar1.mp4" type="video/mp4" />
                        Tu navegador no soporta la reproducción de video.
                    </video>

                    <div className="about-hero-overlay"></div>

                    <div className="about-hero-content text-center text-white">
                        <h1 className="display-4 fw-bold">Contáctanos</h1>
                        <p className="lead">
                            En <strong>Vintage Pro Audio</strong> traemos a Colombia las mejores marcas de audio profesional.
                            Escríbenos por WhatsApp y recibe asesoría personalizada en minutos.
                        </p>
                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <a
                                href="https://wa.me/573013973592?text=Hola,%20quiero%20más%20información%20sobre%20sus%20productos"
                                className="btn btn-success btn-lg px-4"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="bi bi-whatsapp me-2"></i>
                                Chatear por WhatsApp
                            </a>
                        </div>
                    </div>
                </section>



                {/* Información de Contacto secundaria */}
                <section className="contact-info py-5">
                    <div className="container">
                        <div className="row g-4">
                            {/* Redes Sociales */}
                            <div className="col-md-6">
                                <div className="card h-100 border-0 shadow-sm text-center hover-card">
                                    <div className="card-body">
                                        <div className="text-primary mb-3">
                                            <i className="bi bi-share display-4"></i>
                                        </div>
                                        <h3 className="h4 mb-3">Redes Sociales</h3>
                                        <p className="text-muted mb-4">
                                            Síguenos y envíanos un mensaje directo.
                                        </p>
                                        <div className="d-flex justify-content-center gap-3">
                                            <a href="#" className="btn btn-outline-primary btn-lg rounded-circle">
                                                <i className="bi bi-facebook"></i>
                                            </a>
                                            <a href="#" className="btn btn-outline-info btn-lg rounded-circle">
                                                <i className="bi bi-twitter"></i>
                                            </a>
                                            <a href="#" className="btn btn-outline-danger btn-lg rounded-circle">
                                                <i className="bi bi-instagram"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="col-md-6">
                                <div className="card h-100 border-0 shadow-sm text-center hover-card">
                                    <div className="card-body">
                                        <div className="text-danger mb-3">
                                            <i className="bi bi-envelope display-4"></i>
                                        </div>
                                        <h3 className="h4 mb-3">Correo Electrónico</h3>
                                        <p className="text-muted mb-4">
                                            Escríbenos y te responderemos en el menor tiempo posible.
                                        </p>
                                        <a
                                            href="mailto:contacto@vintagepro.com"
                                            className="btn btn-danger btn-lg"
                                        >
                                            <i className="bi bi-envelope me-2"></i>
                                            Enviar correo
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="alert alert-warning text-center fs-8 fw-bold" role="alert">
                        ¿No encuentras lo que buscas? 📦 Chatea con nosotros y con gusto lo cotizamos, incluso si no lo ves en el catálogo.
                    </div>
                </section>
                <ServiceHighlights />
            </main>

            <Footer />
        </div>
    );
}

export default ContactLayout;
